module.exports = __webpack_public_path__ + "img/40_11.aa152dc5.png";